// extracted by mini-css-extract-plugin
export default {"title":"History_title__wh6BT","sectionHeading":"History_sectionHeading__tQh3I"};